import React, { createContext, useContext } from "react";
import MerchantDomainBase from "entities/domain/admin/merchants/merchant-domain";

// Context to provide guaranteed non-null merchant after PrivateRoute guard
export const MerchantContext = createContext<MerchantDomainBase | null>(null);

/**
 * Hook to get merchant that is guaranteed to exist after PrivateRoute guard
 * Use this instead of useMerchant() in components that are rendered inside PrivateRoute
 */
export const useRequiredMerchant = (): MerchantDomainBase => {
  const merchant = useContext(MerchantContext);
  if (!merchant) {
    throw new Error(
      "Merchant is required but was not provided. This should never happen after PrivateRoute guard."
    );
  }
  return merchant;
};
